// Admin dashboard formatting helpers + status/priority meta.
// All actual data now flows from /api/admin/overview and /api/admin/leads.

export const formatKr = (n) => `${Math.round(Number(n) || 0).toLocaleString("da-DK")} kr.`;
export const formatPct = (n) => `${(Number(n) * 100).toFixed(1).replace(".", ",")}%`;
export const formatInt = (n) => `${Math.round(Number(n) || 0).toLocaleString("da-DK")}`;

export const LEAD_STATUS_META = {
    ny: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", label: "Ny" },
    kontaktet: { bg: "bg-cyan-50", text: "text-cyan-700", border: "border-cyan-200", label: "Kontaktet" },
    demo_booket: { bg: "bg-purple-50", text: "text-purple-700", border: "border-purple-200", label: "Demo booket" },
    tilbud_sendt: { bg: "bg-pink-50", text: "text-pink-700", border: "border-pink-200", label: "Tilbud sendt" },
    vundet: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Vundet" },
    tabt: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Tabt" },
};

export const PRIO_META = {
    high: { bg: "bg-red-50", text: "text-red-700", label: "Høj" },
    medium: { bg: "bg-amber-50", text: "text-amber-700", label: "Medium" },
    low: { bg: "bg-emerald-50", text: "text-emerald-700", label: "Lav" },
};

export const LEAD_STAGE_ORDER = ["ny", "kontaktet", "demo_booket", "tilbud_sendt", "vundet", "tabt"];
